export default "__VITE_ASSET__27024582__"